import { Directive, Input } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, Validator, ValidationErrors, Validators } from '@angular/forms';


@Directive({
  selector: '[appPhoneRegex]',
  providers: [{
    provide: NG_VALIDATORS, // Register this directive as a validator
    useExisting: PhoneRegexDirective,
    multi: true // Allow multiple validators to be registered
  }]
})
export class PhoneRegexDirective implements Validator {

  @Input() appPhoneRegex: string | RegExp = /^\+?[\d\s-()]{10,20}$/; // Default regex if not provided

  validate(control: AbstractControl): ValidationErrors | null {
    const value = control.value;

    if (!value) {
      return null; // Let the 'required' validator handle empty values
    }

    const regex = (typeof this.appPhoneRegex === 'string') ? new RegExp(this.appPhoneRegex) : this.appPhoneRegex;

    const isValid = regex.test(value);

    // Return an error object if validation fails, null otherwise
    return isValid ? null : { phoneRegex: { valid: false, value: value } };
  }

}
